import animatedLogo from '../../../assets/icons/cluey_plus_animated_logo.gif';
import spinner from '../../../assets/images/spinner.svg';
import { cn } from '../helpers/cn';

const ClueyPlusLoader = ({ fullScreen = true }: { fullScreen?: boolean }) => {
  return (
    <div className={cn('flex flex-col items-center justify-center gap-5', fullScreen ? 'h-screen' : 'h-[50px]')}>
      <img src={animatedLogo} alt="Loading..." className="h-[50px]" />
    </div>
  );
};

const ClueyPlusSpinner = ({ className }: { className?: string }) => {
  return (
    <div className={cn('flex flex-col items-start justify-center gap-5', className)}>
      <img src={spinner} alt="Loading..." className="size-full animate-spin" />
    </div>
  );
};

export { ClueyPlusSpinner };
export default ClueyPlusLoader;
